import { getFetch, postFetch, postFetchWithBody, postFetchWithToken } from "../../utils/fetch";

async function getUsers(page) {
  const res = await getFetch(`/Users?${page}`);
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}

async function deleteUser(id) {
  const res = await postFetchWithBody(`/Users/delete`, { id: id });
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}

async function storeUser(form) {
  if (form.get("name") === "") {
    return {
      status: "error",
      message: "نام و نام خانوادگی الزامی است!",
    };
  }
  if (form.get("username") === "") {
    return {
      status: "error",
      message: "نام کاربری الزامی است!",
    };
  }
  if (form.get("password") === "") {
    return {
      status: "error",
      message: "رمز عبور الزامی است!",
    };
  }
  if (form.get("melli_code") === "") {
    return {
      status: "error",
      message: "کدملی الزامی است!",
    };
  }
  if (form.get("position") === "") {
    return {
      status: "error",
      message: "سمت الزامی است!",
    };
  }
  if (form.get("role") === "") {
    return {
      status: "error",
      message: "نقش الزامی است!",
    };
  }
  if (form.get("cellphone") === "") {
    return {
      status: "error",
      message: "شماره موبایل الزامی است!",
    };
  }
  const res = await postFetchWithToken("/Users/store", form);
  if (res.status !== "error") {
    if (res.code === "407") {
      return {
        status: "error",
        message: "نام کاربری از قبل برای کاربر دیگر ثبت شده!",
      };
    }
    return {
      status: "success",
      message: "کاربر با موفقیت ایجاد شد",
    };
  } else {
    return {
      status: res.status,
      message: res.message,
    };
  }
}

export { getUsers, storeUser, deleteUser };
